import { Text } from "@volca/ui/components/ui/text";

interface InfoPairProps {
  label: string;
  info?: string | null;
}

const InfoPair = ({ label, info }: InfoPairProps) => (
  <Text>
    <span className="text-subtle">{label}:</span> {info || "Not set"}
  </Text>
);

export default InfoPair;
